import React from "react";
import { ContentEntity } from "@modules/local/db";
import { RamadanBackground } from "./RamadanPage";
import MarkdownView from "react-showdown";
import TranslatedText from "@components/items/display/TranslatedText";

const AllahNameDetailsPage = ({ content }: { content: ContentEntity }) => {
  const text = content.parameters?.find((p) => p.key === "TEXT");
  return (
    <div className="cus-scrollbar-w-none h-full overflow-y-auto">
      <RamadanBackground />
      <div className="flex flex-col gap-24 p-5">
        <TranslatedText
          text="ramadan.allah-name-explanation"
          className="text-[64px] font-bold text-ramadan-primary dark:text-dark-ramadan-primary"
        />
        <div className="flex flex-col gap-6">
          <div className="text-[24px] font-medium text-ramadan-primary dark:text-dark-ramadan-primary">
            {content.title}
          </div>
          <MarkdownView
            markdown={text?.value || ""}
            options={{ tables: true, emoji: true }}
            className="leading-[41px] text-ramadan-primary dark:text-dark-ramadan-primary"
          />
        </div>
      </div>
    </div>
  );
};

export default AllahNameDetailsPage;
